import { render, staticRenderFns } from "./VuesticSwitch.vue?vue&type=template&id=c0835ed0"
import script from "./VuesticSwitch.vue?vue&type=script&lang=js"
export * from "./VuesticSwitch.vue?vue&type=script&lang=js"
import style0 from "./VuesticSwitch.vue?vue&type=style&index=0&id=c0835ed0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0835ed0')) {
      api.createRecord('c0835ed0', component.options)
    } else {
      api.reload('c0835ed0', component.options)
    }
    module.hot.accept("./VuesticSwitch.vue?vue&type=template&id=c0835ed0", function () {
      api.rerender('c0835ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-switch/VuesticSwitch.vue"
export default component.exports